import styles from './ProductDetails.module.scss';

const ProductDetailsDescription = (props: {
    fromSweden?: boolean;
    manufacturer?: string;
    packageSizeInformation?: string;
    consumerInformationText: string[];
    isPharmaceutical?: boolean;
}) => {
    return (
        <div className={styles.Description}>
            <p className="u-marginAz">
                {props.manufacturer && (
                    <span style={{ fontWeight: 'bold' }}>{`${props.manufacturer}.`}</span>
                )}
                {props.packageSizeInformation && <span>{` ${props.packageSizeInformation}.`}</span>}
            </p>

            {!!props.consumerInformationText?.length && (
                <div>{props.consumerInformationText.join(', ')}</div>
            )}

            {!!props.isPharmaceutical && <div>Läkemedel</div>}
        </div>
    );
};

export default ProductDetailsDescription;
